export const wt_kunder = 1000;
export const wt_kontakter = 1001;
export const wt_vikarer = 1002;
export const wt_tilbud = 1003;
export const wt_kandidater = 1004;
export const wt_oppdrag = 1005;
export const wt_rekruttering = 1006;
export const wt_rekrutteringskandidat = 1007;
export const wt_dagbok = 1008;
export const wt_dokumenter = 1009;
export const wt_global = 1010;
export const wt_firma = 1011;
export const wt_avdelinger = 1012;
export const wt_emailbeskjeder = 1013;
export const wt_ansatte = 1014;
export const wt_faktura = 1015;
export const wt_timelister = 1016;
export const wt_timelistegrunnlag = 1017;
export const wt_telefonnummere = 1018;
export const wt_oppdragskostnader = 1019;
export const wt_superglobal = 1020;
export const wt_passord = 1021;
export const wt_grupper = 1022;
export const wt_gruppemedlemmer = 1023;
export const wt_tilbudsutlegg = 1024;
export const wt_uketidsangivelse = 1025;
export const wt_avtaler = 1026;
export const wt_dokumentbehandling = 1027;
export const wt_systemhendelser = 1028;
export const wt_etimelistelinjer = 1029;
export const wt_vikarforvikaren = 1030;
export const wt_eksportfiler = 1031;
export const wt_produkter = 1032;
export const wt_produktpris = 1033;
export const wt_lagretesok = 1034;
export const wt_tekst = 1035;
export const wt_dtekst = 1036;
export const wt_portaloppdatering = 1037;
export const wt_typer = 1038;
export const wt_aaregister = 1039;
export const wt_systemlogg = 1040;
export const wt_kontoutskrift = 1041;
export const wt_firmakunder = 1042;
export const wt_tilskudd = 1043;
export const wt_tilskuddimportert = 1044;
export const wt_vikarpriser = 1045;
export const wt_eksternadresser = 1046;
export const wt_firmavikarer = 1047;
export const wt_vikarersluttet = 1048;
export const wt_rekrutteringsutlegg = 1049;
export const wt_timelinjer = 1050;
export const wt_kurs = 1051;
export const wt_praksis = 1052;
export const wt_skoler = 1053;
export const wt_kunnskap = 1054;
export const wt_engangspassord = 1055;
export const wt_perioder = 1056;
export const wt_linker = 1057;
export const wt_bilde = 1058;
export const wt_firmakontakter = 1059;
export const wt_mva = 1060;
export const wt_mangedageransatt = 1061;
export const wt_mangedagervikar = 1062;
export const wt_automail = 1066;
export const wt_emailvedlegg = 1068;
export const wt_vikarsok = 1069;
export const wt_kundesok = 1070;
export const wt_postnummer = 1071;
export const wt_omraader = 1072;
export const wt_kommuner = 1073;
export const wt_fylker = 1074;
export const wt_tellere = 1075;
export const wt_feilpassord = 1077;
export const wt_importertfraekstern = 1078;
export const wt_importid = 1079;
export const wt_controlrecsets = 1080;
export const wt_helligdager = 1082;
export const wt_telefonlogg = 1083;
export const wt_sesjoner = 1084;
export const wt_emailinn = 1085;
export const wt_emailut = 1086;
export const wt_aaregisterauto = 1087;
export const wt_bankoppdrag = 1088;
export const wt_sjekkliste = 1089;
export const wt_sjekklistevalg = 1090;
export const wt_adresser = 1091;
export const wt_forlengelser = 1092;
export const wt_vikarerpresentert = 1093;
export const wt_avdelingervikarer = 1094;
export const wt_divtekster = 1095;
export const wt_reiseregning = 1096;
export const wt_localtransl = 1097;
export const wt_samtykker = 1098;

export const wt_arkivimport = 9000000;
export const wt_arkivimport_item = 9000001;
export const wt_rssartikkel = 9000002;
export const wt_nyhetsartikkel = 9000003;
export const wt_changelogartikkel = 9000004;

export const wt_ukjent = -3000;

export const wtw_utleide_medarbeidere = 5100;
export const wtw_prosess_crm = 5101;
export const wtw_faktura_omsetning = 5102;
export const wtw_nyhetsfeed = 5103;
export const wtw_ekstern_nettside = 5104;
export const wtw_systemhendelser = 5105;
export const wtw_meldinger_og_epost = 5106;
export const wtw_dagbok = 5107;
export const wtw_kandidater_og_medarbeidere = 5108;
export const wtw_soknader = 5109;
export const wtw_tilbud_og_annonser = 5110;
export const wtw_rekruttering_og_annonser = 5111;
export const wtw_kunder = 5112;
export const wtw_evaluering = 5113;
export const wtw_soknader_rekruttering = 5114;
export const wtw_evaluering_utfort_av_medarbeidere = 5115;
export const wtw_community_widget = 5116;
export const wtw_webtemp_roadmap = 5117;
export const wtw_garantilonnsoversikt = 5118;
export const wtw_nedtelling = 5119;

export const wtw_stolpe = 5200;
export const wtw_sektor_liggende = 5201;
export const wtw_sektor_3d = 5202;
export const wtw_liste = 5203;
export const wtw_liste_med_detaljer = 5204;
export const wtw_speedometer = 5205;
export const wtw_linjegraf = 5206;
export const wtw_trakt = 5207;

export const wtc_dashboard = 0;
export const wtc_search = -2;
export const wtc_utvalg = -3;
export const wtc_groups = -4;
